// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "build/js/" + {"231":"blueprint-icons-split-paths-by-size-loader","524":"npm.blueprintjs","824":"blueprint-icons-all-paths-loader","860":"blueprint-icons-all-paths"}[chunkId] + ".js";
};